import Stepper from "@keyvaluesystems/react-stepper";
import React from "react";
import { useAppSelector } from "../../Redux/hooks";
import { useTranslation } from "react-i18next";
import { GenerateSectionDescription } from "../../Business/utils/SectionUtils";


interface SectionTimeLineProps {
    sectionNames: string[];
    activeStep: number;
    onChangeSection: (step: number) => void;
    inputData: any;
}

export const SectionTimeLine = (props: SectionTimeLineProps) => {
    const { t } = useTranslation();
    const locale = useAppSelector(state => state.locale.locale);
    const [steps, setSteps] = React.useState<any>([]);
    const clientConfig = useAppSelector(state => state.clientConfig?.config);

    const styles = {
        ActiveLabelTitle: () => ({
            color: clientConfig?.primaryColor,
        }),
        ActiveNode: () => ({
            backgroundColor: clientConfig?.primaryColor,
        }),
        InactiveLineSeparator: () => ({
            backgroundColor: "#E1E1E1",
        }),
        LabelDescription: () => ({
            color: "gray",
            fontSize: "14px"
        }),
        ActiveLabelDescription: () => ({
            color: "gray",
            fontSize: "14px"
        })
    }

    React.useEffect(() => {
        if (props) {
            const tmpSteps: any[] = [];

            props.sectionNames.forEach((sectionName) => {
                tmpSteps.push({
                    stepLabel: t(sectionName),
                    stepDescription: <div>{GenerateSectionDescription(props.inputData, sectionName, locale)}</div>
                });
            });

            setSteps(tmpSteps);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    return (
        <Stepper showDescriptionsForAllSteps styles={styles} steps={steps} currentStepIndex={props.activeStep} />
    );
}